var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-descriptions",
    { attrs: { column: 2, border: "" } },
    [
      _c("template", { slot: "title" }, [
        _c(
          "span",
          { staticStyle: { "font-size": "0.875em", "font-weight": "normal" } },
          [_vm._v("开票信息")]
        ),
      ]),
      _c(
        "el-descriptions-item",
        [
          _c("template", { slot: "label" }, [_vm._v("开票类型")]),
          _vm._v(
            "\n\t\t" +
              _vm._s(_vm.getInvoiceTypeName(_vm.invoiceData.invoiceType)) +
              "\n\t"
          ),
        ],
        2
      ),
      _c(
        "el-descriptions-item",
        [
          _c("template", { slot: "label" }, [_vm._v("开票金额")]),
          _vm._v("\n\t\t" + _vm._s(_vm.invoiceData.money) + "元\n\t"),
        ],
        2
      ),
      _c(
        "el-descriptions-item",
        [
          _c("template", { slot: "label" }, [
            _vm._v("\n\t\t\t" + _vm._s(_vm.setTitle) + "\n\t\t"),
          ]),
          _vm._v("\n\t\t" + _vm._s(_vm.invoiceData.identification) + "\n\t"),
        ],
        2
      ),
      _c(
        "el-descriptions-item",
        [
          _c("template", { slot: "label" }, [_vm._v("发票抬头")]),
          _vm._v("\n\t\t" + _vm._s(_vm.invoiceData.title) + "\n\t"),
        ],
        2
      ),
      _vm.invoiceData.invoiceType == 1 && !_vm.isZhuanPiaoHide
        ? [
            _c(
              "el-descriptions-item",
              [
                _c("template", { slot: "label" }, [_vm._v("注册地址")]),
                _vm._v("\n\t\t\t" + _vm._s(_vm.invoiceData.address) + "\n\t\t"),
              ],
              2
            ),
            _c(
              "el-descriptions-item",
              [
                _c("template", { slot: "label" }, [_vm._v("注册电话")]),
                _vm._v("\n\t\t\t" + _vm._s(_vm.invoiceData.phone) + "\n\t\t"),
              ],
              2
            ),
            _c(
              "el-descriptions-item",
              [
                _c("template", { slot: "label" }, [_vm._v("开户银行")]),
                _vm._v(
                  "\n\t\t\t" + _vm._s(_vm.invoiceData.bankName) + "\n\t\t"
                ),
              ],
              2
            ),
            _c(
              "el-descriptions-item",
              [
                _c("template", { slot: "label" }, [_vm._v("开户账号")]),
                _vm._v("\n\t\t\t" + _vm._s(_vm.invoiceData.bankNo) + "\n\t\t"),
              ],
              2
            ),
            _c(
              "el-descriptions-item",
              [
                _c("template", { slot: "label" }, [_vm._v("收件人")]),
                _vm._v(
                  "\n\t\t\t" + _vm._s(_vm.invoiceData.mailName) + "\n\t\t"
                ),
              ],
              2
            ),
            _c(
              "el-descriptions-item",
              [
                _c("template", { slot: "label" }, [_vm._v("手机号")]),
                _vm._v(
                  "\n\t\t\t" + _vm._s(_vm.invoiceData.mailPhone) + "\n\t\t"
                ),
              ],
              2
            ),
            _c(
              "el-descriptions-item",
              [
                _c("template", { slot: "label" }, [_vm._v("收件人地址")]),
                _vm._v(
                  "\n\t\t\t" + _vm._s(_vm.invoiceData.mailAreaName) + "\n\t\t"
                ),
              ],
              2
            ),
            _c(
              "el-descriptions-item",
              [
                _c("template", { slot: "label" }, [_vm._v("详细地址")]),
                _vm._v(
                  "\n\t\t\t" + _vm._s(_vm.invoiceData.mailAddress) + "\n\t\t"
                ),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }